<template>
  <div class="advertDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <div class="advertDetail-radio">
        <div class="radio-label">{{ $t.marketRisk.advertType }}</div>
        <van-radio-group v-model="form.AdvertType" direction="horizontal">
          <van-radio
            v-for="(item, index) in typeValueOptions"
            :key="index"
            :name="item.value"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>
      </div>

      <div class="advertDetail-radio">
        <div class="radio-label">{{ $t.marketRisk.moduleType }}</div>
        <van-radio-group v-model="form.ModuleId" direction="horizontal">
          <van-radio
            v-for="(item, index) in moduleOptions"
            :key="index"
            :name="item.value"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>
      </div>

      <van-field
        v-model="form.AdvertTitle"
        :label="$t.marketRisk.advertTitle"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.AdvertContent"
        :label="$t.marketRisk.advertContent"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.AdvertContentEn"
        :label="$t.marketRisk.advertContentEn"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.LinkParam"
        :label="$t.marketRisk.linkParam"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.LinkUrl"
        :label="$t.marketRisk.lineUrl"
        :placeholder="$t.meta.input"
        type="textarea"
      />

      <van-field
        v-model="form.Sort"
        :label="$t.marketRisk.sort"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field :label="$t.marketRisk.imgUrl">
        <template #input>
          <van-uploader v-model="advertLogo" :max-count="1" :after-read="afterRead1" />
        </template>
      </van-field>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  Uploader,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(Uploader);

export default {
  name: "advertDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      isEdit: false,
      advertId: "",
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      advertLogo: [],
      typeValueOptions: [
        {
          text: this.$t.marketRisk.graphic,
          value: "1",
        },
        {
          text: this.$t.marketRisk.externalLinks,
          value: "2",
        },
      ],
      moduleOptions: [
        {
          text: this.$t.marketRisk.pcStation,
          value: "1",
        },
        {
          text: this.$t.marketRisk.wxStation,
          value: "2",
        },
      ],
    };
  },
  created() {
    const { IsEdit } = this.$route.query;
    this.isEdit = IsEdit;
    if (IsEdit) {
      var data = JSON.parse(localStorage.getItem("advertDetail"));
      this.form = data;
      this.firstLoad();
    } else {
      this.form = {
        AdvertId: "",
        AdvertTitle: "",
        ImgUrl: "",
        AdvertContent: "",
        AdvertContentEn: "",
        AdvertType: "1",
        ModuleId: "1",
        LinkParam: "",
        LinkUrl: "",
        Sort: "",
      };
    }
  },
  methods: {
    firstLoad() {
      if (this.form.ImgUrl) {
        this.advertLogo.push({
          url: this.imgUrlFilter(this.form.ImgUrl),
        });
      }
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CompanyId = this.CompanyId;
      var request = null;
      if (this.isEdit) {
        request = this.$api.marketRisk.editAdvert(param);
      } else {
        request = this.$api.marketRisk.addAdvert(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.ImgUrl = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.advertDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .advertDetail-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      font-size: 14px;
    }
  }
}
</style>
